"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Ansichten-Speicher-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCViews
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCViews} options.module Modulinstanz
 */
gc.gis.module.GCViews.SavePanel = function( options )
{
	const self = this;

	gc.gis.assert.isSet( options );
	this.module = options.module;
	this.loading_queue = 0;

	this._initActionBar();

	const options_widget = {
		className: 'gc-views',
		//target:    '#gc_views_save',
		actionbar: this.widget_action_bar
	};
	gc.gis.widget.GCPanel.call( this, options_widget );

	gc.gis.assert.isInstance( options.module, gc.gis.module.GCViews );

	this.element = this._render();

	this._initContent();

	this.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STARTED, this, function( evt ) {
		self.onLoadingStarted();
	});
	this.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, this, function( evt ) {
		self.onLoadingStopped();
	});
};
gc.gis.module.GCViews.SavePanel.prototype = Object.create( gc.gis.widget.GCPanel.prototype );

/**
 *
 */
gc.gis.module.GCViews.SavePanel.prototype._initActionBar = function()
{
	const self = this;

	this.widget_save = new gc.gis.widget.GCItem({
		label: 'Speichern',
		tooltip: 'Speichert die Ansicht',
		className: 'btn btn-success',
		icon: 'action-apply',
		click: function( evt ) {
            self.form.submit( evt );
		}
	});
	this.widget_cancel = new gc.gis.widget.GCItem({
		label: 'Abbrechen',
		tooltip: 'Bricht das Speichern der Ansicht ab',
		className: 'btn btn-danger',
		icon: 'action-cancel',
		click: function( evt ) {
            self._resetForm();
            gc.gis.iface.ui.sidebar.historyBack();
		}
	});

	this.widget_action_bar = new gc.gis.widget.GCMenu({
		containerClassName: 'actionbar',
		items: [
			this.widget_save,
			this.widget_cancel
		]
	});

	return this.widget_action_bar;
};

/**
 *
 */
gc.gis.module.GCViews.SavePanel.prototype._initContent = function()
{
	const self = this;

	this.element_preview_image_auto = jQuery('<img>', {
		'class': 'gc-views-save-preview-image',
		alt: 'Vorschaubild'
	});
	this.element_preview_image_upload = jQuery('<img>', {
		'class': 'gc-views-save-preview-image',
		alt: 'eigenes Vorschaubild'
	});

	const sub_view_edit = {
		controls: [
			{
				type: 'select',
				label: 'Ansicht',
				name: 'view_id',
				initFunc: function( control ) {
					self.module.on( gc.gis.module.GCViewsEvent.VIEW_LOADING_STOPPED, self, function( evt ) {
						control.updateOptions( control.updateFunc.call( this ) );
					} );
				},
				updateFunc: function() {
					const views = self.module.getOwnViews();
					const options = [{}];
					for (let i=0; i<views.length; i++)
					{
						options.push({
							data:  views[i],
							label: views[i].name,
							value: views[i].id
						});
					}
					return options;
				},
				change: function(evt, control) {
					const id = control.getValue() || false;
					if (id)
					{
						const view = self.module.getViewById(id);
						self.form.getElement('view_name_new').val(view.name);
						self.form.getElement('view_preview_auto').attr('src', view.previewUrl);
						self.form.getElement('view_description').val(view.description);
						const set_default = view.states && (view.states.default === true);
						self.form.get('view_set_default')._element.prop('checked', set_default);
					}
					else
					{
						self.form.getElement('view_name_new').val('');
						self.form.getElement('view_preview_auto').attr('src', '');
						self.form.getElement('view_description').val('');
						self.form.get('view_set_default')._element.prop('checked', false);
					}
				}
			},
			{
				type: 'text',
				label: 'Neuer Name',
				name: 'view_name_new',
				value: ''
			}
		]
	};
	const sub_preview_manual = {
		controls: [
			{
				type: 'custom',
				name: 'view_preview_upload',
				element: self.element_preview_image_upload
			},
			{
				label: 'Bild hochladen',
				type: 'file',
				accept: 'image/*',
				change: function( evt, form, control ) {
					if( control._element.files && control._element.files[0] )
					{
						const reader = new FileReader();
						reader.onload = function( evt2 ) {
							self.element_preview_image_upload.attr('src', evt2.target.result );
						};
						reader.readAsDataURL( control._element.files[0] );
					}
					else
					{
						self.element_preview_image_upload.attr('src', '');
					}
				}
			}
		]
	};
	const sub_preview_auto = {
		controls: [
			{
				type: 'custom',
				name: 'view_preview_auto',
				element: self.element_preview_image_auto
			},
			{
				label: 'Aktualisieren',
				tooltip: 'Vorschaubild aktualisieren',
				type: 'button',
				click: function( evt ) {
					self.element_preview_image_auto.attr('src', self.module.map.getCanvasDump(
						gc.gis.module.GCViewsConstants.DEF_PREVIEW_FORMAT,
						gc.gis.module.GCViewsConstants.DEF_PREVIEW_WIDTH,
						gc.gis.module.GCViewsConstants.DEF_PREVIEW_HEIGHT
					));
				}
			}
		]
	};

	const form_config = {
		className: 'form-views-save',
		controls: [
			{
				type: 'radio',
				name: 'view_mode',
				options: [
					{
						label: 'Neue Ansicht',
						value: 'new',
						default: true,
						change: function( evt, form, control ) {
							self._resetForm();
							self.element_preview_image_auto.attr('src', self.module.map.getCanvasDump(
								gc.gis.module.GCViewsConstants.DEF_PREVIEW_FORMAT,
								gc.gis.module.GCViewsConstants.DEF_PREVIEW_WIDTH,
								gc.gis.module.GCViewsConstants.DEF_PREVIEW_HEIGHT
							));
						},
						subForm: {
							controls: [
								{
									type: 'text',
									label: 'Name',
									name: 'view_name',
									value: ''
								}
							]
						}
					},
					{
						label: 'Ansicht bearbeiten',
						value: 'update',
						change: function( evt, form, control ) {
							self._resetForm();
						},
						subForm: sub_view_edit
					}
				]
			},
			{
				type: 'textarea',
				name: 'view_description',
				label: 'Beschreibung (optional)'
			},
			{
				type: 'checkbox',
				label: 'Als meine Startansicht verwenden',
				name: 'view_set_default',
				value: 'set_default',
				default: false
			},
			{
				type: 'group',
				label: 'Vorschau',
				controls: [
					{
						type: 'radio',
						name: 'view_preview_mode',
						options: [
							{
								label: 'automatisch',
								value: 'auto',
								default: true,
								change: function( evt ) {
									if( !self.element_preview_image_auto.attr('src') )
									{
										self.element_preview_image_auto.attr('src', self.module.map.getCanvasDump(
											gc.gis.module.GCViewsConstants.DEF_PREVIEW_FORMAT,
											gc.gis.module.GCViewsConstants.DEF_PREVIEW_WIDTH,
											gc.gis.module.GCViewsConstants.DEF_PREVIEW_HEIGHT
										));
									}
								},
								subForm: sub_preview_auto
							},
							{
								label: 'eigenes Bild',
								value: 'manual',
								subForm: sub_preview_manual
							}
						]
					}
				]
			}
		],
		// validate: function( form, params ) {
		// // siehe getViewConfig()
		// },
		submit: function(form, params) {
			self.module.saveView( self.getViewConfig() );
			self._resetForm();
		}
	};
	this.form = gc.gis.util.GCFormRenderer.renderForm(form_config);

	// this.element_content.children().remove();
	this.element_content.append( this.form.getElement() );

	this.element_loading = jQuery('<div>', {
		'class': 'gc-views-loading'
	});
	this.element_content.append( this.element_loading );
};

/**
 *
 */
gc.gis.module.GCViews.SavePanel.prototype._resetForm = function()
{
	// this.form.getElement()[0].reset();
	// this.element_preview_image_upload.attr('src', '');
	// this.element_preview_image_auto.attr('src', '');
	this.form.getElement('view_preview_upload').attr('src', '');
	this.form.getElement('view_preview_auto').attr('src', '');
	this.form.getElement('view_id').val('');
	this.form.getElement('view_name').val('');
	this.form.getElement('view_name_new').val('');
	this.form.getElement('view_description').val('');
	this.form.get('view_set_default')._element.prop('checked', false );
};

/**
 *
 */
gc.gis.module.GCViews.SavePanel.prototype.getViewConfig = function()
{
	const view_mode = this.form.getValue('view_mode');

	const view = {
		description: this.form.getElement('view_description').val(),
		viewport: this.module.map.getViewport()
	};

	// Ggf. ID setzen und alten Namen ersetzen
	if (view_mode === 'update')
	{
		view.id   = this.form.getValue('view_id');
		view.name = this.form.getValue('view_name_new');
		// Abbrechen, falls keine Ansicht ausgewählt
		if( !view.id )
		{
			throw new gc.gis.error.GCError('Keine Ansicht ausgewählt.');
		}
	}
	else
	{
		view.name = this.form.getValue('view_name');
	}
	// Abbrechen, falls kein Name gesetzt
	if (!view.name)
	{
		throw new gc.gis.error.GCError('Kein Name für die Ansicht angegeben.');
	}

	const preview_mode = this.form.getValue('view_preview_mode');
	if (preview_mode === 'auto')
	{
		view.previewUpload = this.form.getValue('view_preview_auto');
	}
	else
	{
		view.previewUpload = this.form.getValue('view_preview_upload');
	}

	const set_as_default = this.form.get('view_set_default')._element.is(':checked');
	if (set_as_default)
	{
		view.setDefault = true;
	}

	return view;
};

/**
 *
 */
gc.gis.module.GCViews.SavePanel.prototype.onLoadingStarted = function()
{
	if( this.loading_queue === 0 )
	{
		this.element_loading.show('fade');
	}
	this.loading_queue++;
};

/**
 *
 */
gc.gis.module.GCViews.SavePanel.prototype.onLoadingStopped = function()
{
	this.loading_queue--;

	if( this.loading_queue === 0 )
	{
		this.element_loading.hide('fade');
	}
};
